module.exports = __webpack_public_path__ + "static/media/mobilemobex.82fb97a3.svg";